import { Archive, ArchiveRestore, Building2, Download, Flag, Trash2, UserRoundPlus, X } from "lucide-react";

function ActionSelect({ icon: Icon, label, options, testId, onPick }) {
  return (
    <label className="bulk-action-select" data-testid={`${testId}-wrap`}>
      <Icon size={14} />
      <select data-testid={testId} value="" onChange={(event) => event.target.value && onPick(event.target.value)}>
        <option value="">{label}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export const BoardBulkBar = ({ archived = false, canDelete = false, count, isUpdating, meta, onApply, onClear, onDelete, onExport, onPurge, onRestore }) => (
  <section className="board-bulk-bar" data-testid="staffing-board-bulk-actions">
    <span className="bulk-count"><strong data-testid="bulk-selected-count">{count}</strong> selected</span>
    {archived ? (
      <>
        <button className="bulk-text-button" data-testid="bulk-restore-button" type="button" onClick={onRestore}>
          <ArchiveRestore size={14} /> Restore
        </button>
        <button className="bulk-text-button bulk-danger" data-testid="bulk-purge-button" type="button" onClick={onPurge}>
          <Trash2 size={14} /> Delete permanently
        </button>
      </>
    ) : (
      <>
        <ActionSelect icon={UserRoundPlus} label="Assign recruiter" testId="bulk-recruiter-input" options={meta.recruiters.map((recruiter) => ({ value: recruiter.id, label: recruiter.name }))} onPick={(value) => onApply({ recruiter_id: value })} />
        <ActionSelect icon={Flag} label="Change priority" testId="bulk-priority-input" options={["Urgent", "High", "Standard"].map((value) => ({ value, label: value }))} onPick={(value) => onApply({ priority: value })} />
        <ActionSelect icon={Building2} label="Assign client" testId="bulk-client-input" options={meta.clients.map((client) => ({ value: client.id, label: client.name }))} onPick={(value) => onApply({ client_id: value })} />
        <button className="bulk-text-button" data-testid="bulk-export-button" type="button" onClick={onExport}>
          <Download size={14} /> Export
        </button>
        {canDelete && (
          <button className="bulk-text-button" data-testid="bulk-archive-button" type="button" onClick={onDelete}>
            <Archive size={14} /> Archive
          </button>
        )}
      </>
    )}
    <button className="bulk-text-button bulk-clear" data-testid="bulk-clear-button" type="button" onClick={onClear}>
      <X size={14} /> Clear
    </button>
    {isUpdating && <span className="bulk-updating" data-testid="bulk-updating">Applying…</span>}
  </section>
);
